export default function LastUpdated({ date }) {
  if (!date) return null;
  return <time dateTime={date} className="text-sm font-bold text-neutral-500">Updated {date}</time>;
}
